import { chartColors, getScoreColor } from '@UILibrary/utils'

export const buildHeatMapChartDataProp = (data) => {
  return ([{
    data: data.flatMap(group =>
      group.map(item => ({
        x: item.date,
        y: item.name,
        v: item.value
      }))
    ),
    backgroundColor: (ctx) => {
      const value = ctx.dataset.data[ctx.dataIndex].v
      return getScoreColor(value)
    },
    width: ({ chart }) => (chart.chartArea || {}).width / 12 - 5,
    height: ({ chart }) => Math.min(50, (chart.chartArea || {}).height / 3 - 20),
    borderRadius: 8,
    borderWidth: 1,
  }])
}

export const buildDoughnutChartDataProp = (data) => {
  return ({
    labels: ['Debt', 'Expenses', 'Investments', 'Remainder'],
    datasets: [{
      label: ['Debt', 'Expenses', 'Investments', 'Remainder'],
      data: data,
      backgroundColor: [
        chartColors['salmon-pink-50'],  // Debt
        chartColors['golden-rod-50'],   // Expenses
        chartColors['forest-green-50'], // Investments
        chartColors['gray-80'],         // Remainder
      ],
      hoverOffset: 4,
    }]
  })
}
